import { render, staticRenderFns } from "./InsuranceVendor.vue?vue&type=template&id=fbf22430&scoped=true&"
import script from "./InsuranceVendor.vue?vue&type=script&lang=js&"
export * from "./InsuranceVendor.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceVendor.vue?vue&type=style&index=0&id=fbf22430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf22430",
  null
  
)

export default component.exports